/* global OCmodel */
import { isAndroid, isiOS } from 'helper/env';
import { setAuth } from 'helper/configAuth';
import fectx from 'helper/fectx';
import statistic from './statistic';
import './common';

let initResolve;
const initPromise = new Promise(resolve => {
  initResolve = resolve;
});
let token = null;
let loginCb = null;
let shareCb = null;
let shareData = {};

if (process.env.NODE_ENV === 'development') {
  const Nothing = (() => {
    const fn = () => Nothing;
    fn.toString = fn.toLocaleString = fn[Symbol.toPrimitive] = () => '';
    fn.valueOf = () => false;

    return new Proxy(fn, {
      get: (o, key) => (o.hasOwnProperty(key) ? o[key] : Nothing),
    });
  })();
  window.OCmodel = Nothing;
}

function setToken(value) {
  token = value;
  setAuth('ustr', token);
}

function clearToken() {
  token = null;
}

export function getToken() {
  return token;
}

export function init() {
  console.log('in App');

  fectx.interceptors.response.use(response => {
    // eslint-disable-next-line eqeqeq
    if (response.status == '403' && response.data && response.data.InnerData === '用户信息无效') {
      logout();
      login();
    }

    return response;
  });

  if (isAndroid) {
    console.log('Android inject:', window.OCmodel);
    window.OCmodel.getAppInfo(); //调用原生方法
  } else if (isiOS) {
    console.log('iOS inject:', typeof OCmodel, OCmodel);
    OCmodel.getAppInfo(); //调用原生方法
  }

  return initPromise.then(() => {
    // hooks: after init
    // 在此发送统计确保拿到用户标识符
    statistic(2);
  });
}

export function bindPhone() {
  throw new Error('App.bindPhone should never be called!');
}

export function isLogin() {
  const token = getToken();
  return token !== undefined && token !== null && token !== '';
}

export function login(cb) {
  // mock(
  //   'ESWkaLG3T8joYlR5OhUjHO9bScUDjuvY9WsOnTrhV2J%2fs9o0t%2fLOOZX9a6Iarv5PW5mDldPdQdU%3d'
  // );
  // cb();

  loginCb = cb;
  if (isAndroid) {
    window.OCmodel.showLoginPopup(); //调用原生方法：登录
  } else if (isiOS) {
    OCmodel.showLoginPopup(); //调用原生方法：登录
  }
}

//设置原生app的头名称
export function setTitle(title) {
  if (isAndroid) {
    window.OCmodel.setInnerTitle(title); //调用原生方法：设置app的头名称
  } else if (isiOS) {
    OCmodel.setInnerTitle(title); //调用原生方法：设置app的头名称
  }
}

export function setShareData({ title, description, imageUrl, url, onSuccess } = {}) {
  shareData = {
    title: title ? title : document.title,
    description: description,
    imageUrl: imageUrl,
    url: url,
  };

  if (onSuccess) {
    shareCb = onSuccess;
  }
}

//调用原生app的分享
export function shareUrl() {
  statistic(1);
  if (isAndroid) {
    window.OCmodel.goShareUrl(JSON.stringify(shareData)); //调用原生方法：分享
  } else if (isiOS) {
    OCmodel.goShareUrl(shareData); //调用原生方法：分享
  }
}

export function logout() {
  clearToken();
}

export function gotoUrl(url) {
  window.location.href = url;
}

export function mock(si) {
  initResolve();
  setToken(si);
}

export function choosePay() {
  // do nothing;
  // should not be called
}

// //原生app内跳转链接
// export function goPage(url) {
//   if (isAndroid) {
//     window.OCmodel.goPage(url); //调用原生方法：原生跳转链接
//   } else if (isiOS) {
//     OCmodel.goPage(url); //调用原生方法：原生跳转链接
//   }
// }

// //原生app内跳转到商品详情页
// export function goItem(itemInfoId) {
//   if (isAndroid) {
//     window.OCmodel.goItem(itemInfoId); //调用原生方法：跳转到原生商品详情页
//   } else if (isiOS) {
//     OCmodel.goItem(itemInfoId); //调用原生方法：跳转到原生商品详情页
//   }
// }

//原生app打开本页连接后回调的js方法
window.initializeAsyn = si => {
  initResolve();

  console.log('app callinitializeAsyn with:', si);
  if (si) {
    let token;
    if (isAndroid) {
      token = encodeURIComponent(si);
    } else {
      token = si;
    }
    console.log('normalized si:', token);
    setToken(token);
  }

  if (loginCb) {
    console.log('exec login callback:', si);
    loginCb();
  }
};

//原生app分享到微信后，用户从微信转回app时原生回调的js方法
window.shareResult = status => {
  console.log('app share result', status);
  // eslint-disable-next-line eqeqeq
  if (status == 1) {
    if (shareCb) {
      shareCb();
    }
  }
};
